import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from 'ng-recaptcha';

import { AppComponent } from './app.component';
import { LandingRoutingModule } from './landing.route.module';
import { AlertDialogComponent } from './basic/alert-dialog/alert-dialog.component';
import { WelcomeComponent } from './views/welcome/welcome.component';
import { environment } from '../environments/environment';
import { MatSnackBarModule } from '@angular/material/snack-bar';

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    AlertDialogComponent,
    BrowserModule,
    BrowserAnimationsModule, // Necesario para Angular Material
    HttpClientModule, // Necesario para las peticiones HTTP
    RecaptchaV3Module, // Módulo de RecaptchaV3
    RouterModule.forRoot([]), // Configuración del router principal
    LandingRoutingModule,
    MatSnackBarModule,
    WelcomeComponent // Componente standalone debe ir en imports
  ],
  providers: [
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useValue: environment.recaptchaSiteKey
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
